import { Bill } from 'utils/api/models/bills/bills';

const prepareData = (
	validation: types.payment.IValidation,
	formData: types.payment.IFormData,
	bills: Bill[],
	billingId: string,
	accountType: string,
	DISABLE_SMART_PAY?: boolean
) => {
	let items: any[] = bills.map((bill) => ({
		accountId: billingId,
		accountType: accountType,
		billingType: 'POSTPAID',
		code: bill.billNo,
		quantity: '1',
		type: 'BILL',
		unitPrice: bill.unpaidAmount,
	}));

	const payload: any = {
		type: 'PAY',
		totalPrice: items.reduce((acc, curr) => {
			return acc + parseFloat(curr.unitPrice);
		}, 0),
		billingAddress: {
			firstName: formData.holder,
			lastName: formData.holder,
			country: 'OM',
			email: formData.email,
		},
		items,
	};

	if (formData.type === 'card') {
		payload.card = {
			type: validation.number!.card!.type!.toUpperCase(),
			number: formData.number,
			cvv: formData.cvv,
			expiration: {
				month: validation.date.month,
				year: validation.date.year,
			},
		};
	} else {
		payload.paymentToken = formData.tokenId;
	}

	payload.createPaymentToken = formData.saveCard;
	payload.quantity = 1;
	payload.DISABLE_SMART_PAY = DISABLE_SMART_PAY;
	return payload;
};

export default prepareData;
